import React, { FunctionComponent } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { Button } from "Shared";
import { SecondaryButton } from "Shared/Buttons";
import "./StepContent.scss";

interface Props {
    nextText?: string;
    skipText?: string;
    onSkipClick?(): void;
    onBackClick?(): void;
    onNextClick?(): void;
}

const StepContent: FunctionComponent<Props & WithTranslation> = ({
    children,
    nextText,
    skipText,
    onBackClick,
    onNextClick,
    onSkipClick,
    t,
}) => (
    <div className="StepContent">
        <div>{children}</div>

        <div className="StepContent__actions">
            <hr className="StepContent__horizontal-line" />

            <div className="StepContent__actions-row">
                <div className=" StepContent__actions-secondary-container">
                    <Button
                        className="btn StepContent__actions-secondary"
                        text={t("ContinueDeal.StepContent.back")}
                        onClick={onBackClick}
                    />
                </div>
                <div className="StepContent__actions-primary-container">
                    <SecondaryButton onClick={onNextClick}>
                        {nextText ? nextText : t("ContinueDeal.nextBtn")}
                    </SecondaryButton>
                </div>
            </div>

            {skipText && (
                <div className="StepContent__actions-row">
                    <div className="StepContent__actions-betweener" />

                    {/* eslint-disable-next-line */}
                    <a className="StepContent__actions-skip" onClick={onSkipClick}>
                        {skipText}
                    </a>
                </div>
            )}
        </div>
    </div>
);

export default withTranslation()(StepContent);
